const Like = () => {
  return (
    <div className="w-full h-[calc(100%-50px-85px)] flex justify-center items-center">
      <p>개발중</p>
    </div>
  );
};
export default Like;
